import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  SupplierFilterSupplierWarehouse,
  SupplierUpdateSupplierWarehouse,
  SupplierCreateSupplierWarehouse,
  SupplierFilterWarehouseType,
} from "../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "../../Component/InputCus/Select/Select";

function SupplierWarehouseAE() {
  const [isLoading, setLoading] = useState(true);
  const [form, setForm] = useState({});
  const navigate = useNavigate();
  const [warehouseType, setWarehouseType] = useState([]);

  let { id, extra } = useParams();

  const start = async () => {
    try {
      const SupplierFilterWarehouseTypeData = await SupplierFilterWarehouseType(
        {}
      );
      if (
        SupplierFilterWarehouseTypeData.status &&
        SupplierFilterWarehouseTypeData.status === 200
      ) {
        setWarehouseType(SupplierFilterWarehouseTypeData.data.data.data);
      }
      if (extra) {
        const SupplierFilterSupplierWarehouseData =
          await SupplierFilterSupplierWarehouse({
            id: extra,
          });
        if (
          SupplierFilterSupplierWarehouseData.status &&
          SupplierFilterSupplierWarehouseData.status === 200
        ) {
          setForm(SupplierFilterSupplierWarehouseData.data.data.data[0]);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    if (form.name === "") {
      toast.error("نام را وارد نمایید ");
      validation = false;
    }
    if (form.city === "") {
      toast.error("شهر را وارد نمایید ");
      validation = false;
    }
    if (form.address === "") {
      toast.error("ادرس را وارد نمایید ");
      validation = false;
    }
    if (form.phone === "") {
      toast.error("شماره را وارد نمایید ");
      validation = false;
    }
    if (form.fullName === "") {
      toast.error("نام کامل را وارد نمایید ");
      validation = false;
    }
    if (form.warehouseTypeId === "") {
      toast.error("نوع کامل را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        if (extra) {
          const SupplierUpdateSupplierWarehouseData =
            await SupplierUpdateSupplierWarehouse(form);
          if (
            SupplierUpdateSupplierWarehouseData.status &&
            SupplierUpdateSupplierWarehouseData.status === 200
          ) {
            toast.success("بروزرسانی با موفقیت انجام شد");
            navigate("/Panel/Suppliers/Warehouse/" + id);
          }
        } else {
          const SupplierCreateSupplierWarehouseData =
            await SupplierCreateSupplierWarehouse({
              ...form,
              SupplierId: id,
            });
          if (
            SupplierCreateSupplierWarehouseData.status &&
            SupplierCreateSupplierWarehouseData.status === 200
          ) {
            toast.success("افزودن با موفقیت انجام شد");
            navigate("/Panel/Suppliers/Warehouse/" + id);
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-wrap  ">
              <InputCus
                className="m-2"
                type="text"
                name="name"
                id="name"
                text="نام"
                value={form.name || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                type="text"
                name="city"
                id="city"
                text="شهر"
                value={form.city || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                type="text"
                name="address"
                id="address"
                text="ادرس"
                value={form.address || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                type="text"
                name="phone"
                id="phone"
                text="شماره"
                value={form.phone || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                type="text"
                name="fullName"
                id="fullName"
                text="نام کامل"
                value={form.fullName || ""}
                onChange={handleChangeSearch}
              />

              <Select
                className="m-2"
                type="number"
                name="warehouseTypeId"
                id="warehouseTypeId"
                text="نوع"
                value={form.warehouseTypeId || ""}
                onChange={handleChangeSearch}
                option={warehouseType.map((item) => {
                  let data = {
                    value: item.id,
                    title: item.name,
                  };
                  return data;
                })}
              />
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                {extra ? "ویرایش" : "افزودن"}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupplierWarehouseAE;
